import { CheckCircle2, ArrowRight } from "lucide-react";
import { Section, Overline, PrimaryButton, QuoteBanner, IconBadge } from "../components/Shared";
import { SERVICES } from "../lib/data";
import { Seo } from "../components/Seo";
import { servicesSchema } from "../lib/seo";

const SCHEMA = [servicesSchema()];
const CRUMBS = [["Services", "/services"]];

export default function Services() {
  return (
    <>
      <Seo page="services" jsonLd={SCHEMA} breadcrumbs={CRUMBS} />
      <Section className="pt-36">
        <div className="max-w-3xl">
          <Overline>Our Mapping Services</Overline>
          <h1 className="mt-5 text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight leading-[1.1]">
            Every layer of your waterbody, professionally mapped
          </h1>
          <p className="mt-6 text-lg sm:text-xl text-slate-700 leading-relaxed">
            We're a full-service mapping company. Our team collects the sonar and GPS data on-site, then
            processes it into the deliverables below. Choose one service or combine them into a single survey.
          </p>
          <div className="mt-8">
            <PrimaryButton to="/request-a-quote" testId="services-top-quote-button">
              Request a Quote <ArrowRight className="w-4 h-4" />
            </PrimaryButton>
          </div>
        </div>
      </Section>

      <Section className="pt-0 space-y-20">
        {SERVICES.map((s, idx) => (
          <div
            key={s.slug}
            id={s.slug}
            data-testid={`service-detail-${s.slug}`}
            className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center ${
              idx % 2 === 1 ? "lg:[direction:rtl]" : ""
            }`}
          >
            <div className="lg:[direction:ltr]">
              <div className="rounded-2xl overflow-hidden border border-slate-200 bg-slate-900 shadow-xl">
                <img src={s.image} alt={s.title} className="w-full h-full object-cover aspect-[4/3]" />
              </div>
            </div>
            <div className="lg:[direction:ltr]">
              <IconBadge icon={s.icon} className="mb-5" />
              <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">{s.title}</h2>
              <p className="mt-4 text-slate-700 text-lg leading-relaxed">{s.desc}</p>
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
                {s.deliverables.map((d) => (
                  <div key={d} className="flex items-center gap-2.5 text-base text-slate-700">
                    <CheckCircle2 className="w-5 h-5 text-cyan-600 shrink-0" />
                    {d}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </Section>

      <QuoteBanner />
    </>
  );
}
